export default {
  channel: 'Channel',
  spend: 'Spend',
  share: 'Share',
  copy: 'Copy to clipboard',
  copied: 'Copied!',
  copyFailed: 'Could not copy',
  dataView: 'Data View',
  close: 'Close',
  refresh: 'Refresh',
  saveAsImage: 'Save as Image'
}
